import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Accessibility.css';

const Accessibility = () => {
  return (
    <>
      <Helmet>
        <title>הצהרת נגישות - Auto Cross</title>
        <meta name="description" content="הצהרת נגישות של אתר Auto Cross על פי חוק שוויון זכויות לאנשים עם מוגבלות, התשנ״ח-1998" />
      </Helmet>
      
      <div className="accessibility-page">
        <div className="container">
          <header>
            <h1>הצהרת נגישות</h1>
            <p className="last-updated">עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</p>
          </header>

          <main>
            <section aria-labelledby="commitment-title">
              <h2 id="commitment-title">מחויבות לנגישות</h2>
              <p>
                Auto Cross מחויבת להנגיש את שירותיה לכלל הציבור, כולל אנשים עם מוגבלויות. 
                אנו פועלים להנגשת האתר בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, התשנ״ח-1998 
                ולתקן הישראלי ת״י 5568 ברמת AA.
              </p>
            </section>

            <section aria-labelledby="accessibility-features-title">
              <h2 id="accessibility-features-title">תכונות נגישות באתר</h2>
              <ul>
                <li>ניווט באמצעות מקלדת בלבד</li>
                <li>תמיכה בקוראי מסך</li>
                <li>טקסט חלופי לתמונות</li>
                <li>ניגודיות צבעים מתאימה</li>
                <li>כותרות מובנות היטב</li>
                <li>קישור לדילוג לתוכן הראשי</li>
                <li>תיאורים ברורים לקישורים וכפתורים</li>
                <li>תמיכה בזום עד 200% ללא אובדן פונקציונליות</li>
              </ul>
            </section>

            <section aria-labelledby="keyboard-navigation-title">
              <h2 id="keyboard-navigation-title">ניווט במקלדת</h2>
              <p>ניתן לנווט באתר באמצעות המקלדת בלבד:</p>
              <ul>
                <li><kbd>Tab</kbd> - מעבר לאלמנט הבא</li>
                <li><kbd>Shift + Tab</kbd> - מעבר לאלמנט הקודם</li>
                <li><kbd>Enter</kbd> או <kbd>Space</kbd> - הפעלת קישורים וכפתורים</li>
                <li><kbd>Esc</kbd> - סגירת תפריטים נפתחים</li>
              </ul>
            </section>

            <section aria-labelledby="known-issues-title">
              <h2 id="known-issues-title">בעיות ידועות ומגבלות</h2>
              <p>
                אנו עובדים באופן מתמיד לשיפור נגישות האתר. אם נתקלתם בבעיית נגישות, 
                אנא פנו אלינו ונעשה כמיטב יכולתנו לפתור אותה.
              </p>
            </section>

            <section aria-labelledby="feedback-title">
              <h2 id="feedback-title">משוב ופניות</h2>
              <p>אנו מעוניינים לשמוע על החוויה שלכם באתר ולקבל הצעות לשיפור הנגישות.</p>
              
              <div className="contact-info">
                <h3>פרטי התקשרות:</h3>
                <address>
                  <p>
                    <strong>טלפון:</strong> 
                    <a href="tel:03-3820232" aria-label="התקשר לטלפון 03-3820232">03-3820232</a>
                  </p>
                  <p>
                    <strong>אימייל:</strong> 
                    <a href="mailto:Office@auto-cross.co.il" aria-label="שלח אימייל ל Office@auto-cross.co.il">Office@auto-cross.co.il</a>
                  </p>
                  <p>
                    <strong>כתובת:</strong> התמר 3, אבן יהודה
                  </p>
                </address>
              </div>
            </section>

            <section aria-labelledby="compliance-title">
              <h2 id="compliance-title">תאימות לתקנים</h2>
              <p>האתר נבנה בהתאם לתקנים הבאים:</p>
              <ul>
                <li>תקן ישראלי ת״י 5568 ברמת AA</li>
                <li>Web Content Accessibility Guidelines (WCAG) 2.1 ברמת AA</li>
                <li>חוק שוויון זכויות לאנשים עם מוגבלות, התשנ״ח-1998</li>
              </ul>
            </section>

            <section aria-labelledby="updates-title">
              <h2 id="updates-title">עדכונים</h2>
              <p>
                הצהרת נגישות זו נבדקת ומתעדכנת באופן שוטף. 
                עדכון אחרון בוצע ב-{new Date().toLocaleDateString('he-IL')}.
              </p>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default Accessibility;
